module.exports = __webpack_public_path__ + "static/media/mercedes-26189.b5184c66.png";